import React from 'react';
import ThemedSegment from 'components/semantic/Segment';
import { Button, Grid, Icon } from 'semantic';
import { Tariff } from 'screens/GroupsAndPolicies/types';

type Props = {
  onRemove?: () => void;
  onEdit?: () => void;
  values?: Tariff;
};

export const TariffPreview = (props: Props) => {
  return (
    <ThemedSegment offbackground>
      {/* TODO: there must be a better way to align this with Semantic? */}
      <Grid columns="equal" verticalAlign="middle">
        <Grid.Row>
          <Grid.Column style={{ width: '1rem', flexGrow: 0 }}>
            <Icon name="resize vertical" />
          </Grid.Column>
          <Grid.Column width={8}>
            <p>--Formatted Tariff--</p>
          </Grid.Column>
          <Grid.Column floated="right" width={2}>
            {props.onEdit && (
              <Button icon="edit" basic size="mini" onClick={props.onEdit} />
            )}
            {props.onRemove && (
              <Button
                icon="trash"
                basic
                size="mini"
                onClick={props.onRemove} // TODO: add prompt?
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ThemedSegment>
  );
};
